const endpoints = {
  addNewCaregiver: "/caregiver_referral/add-new-caregiver",
  postOneReferralSMS: "/caregiver_referral/send-one-referral-sms",
  getCaregiverReferralBonus:
    "/caregiver_referral/calculate-caregiver-referral-bonus",
};

export default endpoints;
